import React from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'

import { useQueryPaginator } from 'src/components/Table'
import { MarketDetailTable } from 'src/components/Table/detail/Market'
import { MarketDialog } from 'src/modules/supply_chain/components/MarketDialog'
import { FacilityListTable } from 'src/components/Table/list/Facility'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'


export const MarketPage = () => {
  const { guid } = useParams()

  const market = useQuery(['market-details', guid], () => skuit.sc.markets.retrieve(guid))
  const facilityPaginator = useQueryPaginator('facility-list', skuit.sc.facilities.list, {
    params: { page_size: 5, markets: guid },
  })

  const refresh = () => {
    market.refetch()
  }

  return (
    <>
      <DetailPage
        obj={market}
        title="Market"
        refresh={refresh}
        breadcrumbs={[{ title: 'Dashboard', url: '/' }, { title: 'Markets', url: '/warehouse/markets' }]}
        detailComponent={<MarketDetailTable obj={market} refresh={refresh} />}
        createDialog={{ title: 'New Market', Dialog: MarketDialog }}
      >
        <FacilityListTable 
          paginator={facilityPaginator}
          fields={["name", "address"]}
        />
      </DetailPage>
    </>
  )
}
